import React from 'react';
import '../RichTextEditor.css';

const FormatToolbar = props => (
  <div className='rte-format-toolbar'>
    <div style={{ marginLeft: 4, marginRight: 4 }}>
      { props.children }
    </div>
  </div>
);

export default FormatToolbar;
